// React Required
import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

// Create Import File
import './index.scss';

// Common Layout
// import Layout from "./component/common/App";


// Home layout
import AmbientVisions from './home/AmbientVisions';
import PrivacyPolicy from './home/PrivacyPolicy';
import Error404 from "./elements/error404";

import { BrowserRouter, Routes, Route  } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';

class Root extends Component{
    render(){
        return(
            <BrowserRouter
                basename={'/'}
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true
                }}
            >
                <Routes>
                    <Route path={`${process.env.PUBLIC_URL}/`} element={<AmbientVisions />} />
                    <Route path={`${process.env.PUBLIC_URL}/privacy`} element={<PrivacyPolicy />} />
                    <Route path={`${process.env.PUBLIC_URL}/404`} element={<Error404 />} />
                    <Route path="*" element={<Error404 />} />
                </Routes>
            </BrowserRouter>
        )
    }
}

const root = createRoot(document.getElementById('root'));
root.render(<Root/>);
serviceWorker.register();